import { createStore } from "satcheljs";
import { MuteScheduleGroupDialogStoreSchema } from "./schema/MuteScheduleGroupDialogStoreSchema";

const muteScheduleGroupDialogStore = createStore<MuteScheduleGroupDialogStoreSchema>(
    "muteScheduleGroupDialogStore",
    {
        isShown: false,
        actionTaken: null,
        onConfirm: null,
        onCancel: null
    }
);

export default muteScheduleGroupDialogStore;
